import styles from "./ComboBoxBlock.module.scss";

import { useState } from "react";

// components
import { Heading, ComboBox } from "../../Components";

const MockOptions = [
  { label: "Alabama", value: "AL" },
  { label: "Alaska", value: "AK" },
  { label: "Arizona", value: "AZ" },
  { label: "Arkansas", value: "AR" },
  { label: "California", value: "CA" },
];

export default function ComboBoxBlock() {
  return (
    <div className={styles["combo-box-block-root"]}>
      <Heading title="Input" />

      <div style={{ marginTop: "32px" }} />

      <div className={styles["block"]}>
        <span className={styles["label"]}>Default</span>
        <ComboBox
          id="state-list"
          name="state-list"
          label="Select a state"
          options={MockOptions}
          onChange={(val) => console.log(val)}
        />
      </div>
    </div>
  );
}
